module.exports = __webpack_public_path__ + "static/media/bracelets4La.21670653.jpg";